import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, moreHref, moreLabel }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="font-label text-[11px] tracking-[0.3em] text-accent-600">{eyebrow}</p>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {moreHref && (
        <Link
          to={moreHref}
          className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
        >
          {moreLabel ?? "查看全部"}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}